import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { processSteps } from '../../../mocks/servicesData';

export default function ProcessSection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: stepsRef, isVisible: stepsVisible } = useScrollAnimation({ rootMargin: '0px 0px -50px 0px' });

  return (
    <section className="py-28 bg-stone-950 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent"></div>
      <div className="absolute top-1/4 right-0 w-80 h-80 bg-amber-500/5 rounded-full blur-3xl"></div>

      <div className="max-w-6xl mx-auto px-6 relative">
        <div
          ref={headerRef}
          className={`text-center mb-16 scroll-animate ${headerVisible ? 'visible' : ''}`}
        >
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 h-px bg-gradient-to-r from-transparent to-amber-500"></div>
            <span className="text-amber-400 text-xs font-semibold tracking-[0.25em] uppercase">
              How It Works
            </span>
            <div className="w-12 h-px bg-gradient-to-l from-transparent to-amber-500"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-display font-normal text-white mb-5">
            From Vision to Reality
          </h2>
          <p className="text-white/50 max-w-2xl mx-auto leading-relaxed">
            Our streamlined four-step process ensures a stress-free experience from your very first call to the final farewell.
          </p>
        </div>

        <div
          ref={stepsRef}
          className={`grid md:grid-cols-4 gap-6 stagger-children ${stepsVisible ? 'visible' : ''}`}
        >
          {processSteps.map((step, idx) => (
            <div key={step.step} className="relative text-center group">
              {idx < processSteps.length - 1 && (
                <div className="hidden md:block absolute top-10 left-[60%] w-[80%] h-px bg-gradient-to-r from-amber-500/40 to-transparent"></div>
              )}
              <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-amber-500/10 to-yellow-500/5 border border-amber-500/20 flex items-center justify-center mx-auto mb-5 group-hover:border-amber-400/50 transition-all">
                <i className={`${step.icon} text-2xl text-amber-400`}></i>
              </div>
              <div className="text-amber-500/40 text-xs font-semibold tracking-wider mb-2">
                STEP {step.step}
              </div>
              <h3 className="text-lg font-serif font-semibold text-white mb-2">{step.title}</h3>
              <p className="text-white/40 text-sm leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
